import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingPricing(props) {

  const [pricing, setPricing] = useState({
    mrp: "",
    salePrice: "",
    minPrice: "",
    maxPrice: ""
  });
  const [currency, setCurrency] = useState("");

  const CURRENCY_LIST = [
    { code: "INR", label: "INR - Indian Rupee" },
    { code: "USD", label: "USD - US Dollar" },
    { code: "EUR", label: "EUR - Euro" },
    { code: "GBP", label: "GBP - British Pound" },
    { code: "AED", label: "AED - UAE Dirham" },
    { code: "SAR", label: "SAR - Saudi Riyal" },
    { code: "QAR", label: "QAR - Qatari Riyal" },
    { code: "KWD", label: "KWD - Kuwaiti Dinar" },
    { code: "BHD", label: "BHD - Bahraini Dinar" },
    { code: "OMR", label: "OMR - Omani Rial" },
    { code: "CAD", label: "CAD - Canadian Dollar" },
    { code: "AUD", label: "AUD - Australian Dollar" },
    { code: "NZD", label: "NZD - New Zealand Dollar" },
    { code: "SGD", label: "SGD - Singapore Dollar" },
    { code: "HKD", label: "HKD - Hong Kong Dollar" },
    { code: "JPY", label: "JPY - Japanese Yen" },
    { code: "CNY", label: "CNY - Chinese Yuan" },
    { code: "KRW", label: "KRW - South Korean Won" },
    { code: "THB", label: "THB - Thai Baht" },
    { code: "MYR", label: "MYR - Malaysian Ringgit" },
    { code: "IDR", label: "IDR - Indonesian Rupiah" },
    { code: "PHP", label: "PHP - Philippine Peso" },
    { code: "VND", label: "VND - Vietnamese Dong" },
    { code: "BDT", label: "BDT - Bangladeshi Taka" },
    { code: "PKR", label: "PKR - Pakistani Rupee" },
    { code: "LKR", label: "LKR - Sri Lankan Rupee" },
    { code: "NPR", label: "NPR - Nepalese Rupee" },
    { code: "ZAR", label: "ZAR - South African Rand" },
    { code: "EGP", label: "EGP - Egyptian Pound" },
    { code: "NGN", label: "NGN - Nigerian Naira" },
    { code: "TRY", label: "TRY - Turkish Lira" },
    { code: "RUB", label: "RUB - Russian Ruble" },
    { code: "CHF", label: "CHF - Swiss Franc" },
    { code: "SEK", label: "SEK - Swedish Krona" },
    { code: "NOK", label: "NOK - Norwegian Krone" },
    { code: "DKK", label: "DKK - Danish Krone" },
    { code: "PLN", label: "PLN - Polish Zloty" },
    { code: "CZK", label: "CZK - Czech Koruna" },
    { code: "HUF", label: "HUF - Hungarian Forint" },
    { code: "ILS", label: "ILS - Israeli Shekel" },
    { code: "MXN", label: "MXN - Mexican Peso" },
    { code: "BRL", label: "BRL - Brazilian Real" },
    { code: "ARS", label: "ARS - Argentine Peso" },
    { code: "CLP", label: "CLP - Chilean Peso" },
    { code: "COP", label: "COP - Colombian Peso" },
    { code: "PEN", label: "PEN - Peruvian Sol" },
  ];

  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPricing({
      ...pricing,
      [name]: value
    });
  };

  return (

    <Container>

      <Row>

        {/* Page Title */}

        <Col md={12} className="mt-2 mb-2">
          <h4>Step 7 : Pricing</h4>
        </Col>


        {/* Pricing Card */}

        <Col md={12}>

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Currency : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  value="USD"
                  // onChange={handleCurrencyChange}
                />
                  {/* <option value="">-- Select Currency --</option>
                  {CURRENCY_LIST.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.label}
                    </option>
                  ))}
                </Input> */}
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">MRP : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="mrp"
                  // value={pricing.mrp}
                  value="$20.98"
                  onChange={handleChange}
                  // placeholder="Enter MRP"
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Sale Price : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="salePrice"
                  // value={pricing.salePrice}
                  value="$20.98"
                  onChange={handleChange}
                  // placeholder="Enter Sale Price"
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Minimum Price :</Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="minPrice"
                  // value={pricing.minPrice}
                  value="$20.98"
                  // onChange={handleChange}
                  // placeholder="Enter Minimum Price"
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Maximum Price : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="maxPrice"
                  // value={pricing.maxPrice}
                  // onChange={handleChange}
                  value="$20.98"
                  // placeholder="Enter Maximum Price"
                />
              </Col>
            </Row>

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingPricing;